import CustomerCard from "./customerCard";

export default CustomerCard;